/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { PublicFilterDomainConditionDto } from './PublicFilterDomainConditionDto';

export type PublicAssetFilterDomainConditionDto = (PublicFilterDomainConditionDto & {
    /**
     * List of the assets in the condition in URI format. <a href="https://docs.siffletdata.com/docs/uri">[Read more about URIs]</a>
     */
    assets?: Array<string>;
    /**
     * Operator of the condition
     */
    operator?: PublicAssetFilterDomainConditionDto.operator;
} & {
    /**
     * List of the assets in the condition in URI format. <a href="https://docs.siffletdata.com/docs/uri">[Read more about URIs]</a>
     */
    assets: Array<string>;
    /**
     * Operator of the condition
     */
    operator: PublicAssetFilterDomainConditionDto.operator;
});

export namespace PublicAssetFilterDomainConditionDto {

    /**
     * Operator of the condition
     */
    export enum operator {
        IS = 'IS',
        IS_NOT = 'IS_NOT',
    }


}
